import { useContext, useState, useRef, useEffect } from 'react';
import { getLayerName } from '../utils.js';
import { SourceChildContext } from '../context.js';

// import { Layer } from '../type';
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};
function removeUndefined(obj) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cleanNewLayerOptions = {};
  Object.keys(obj).forEach(key => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (key && obj[key]) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cleanNewLayerOptions[key] = obj[key];
    }
  });
  return cleanNewLayerOptions;
}
function MapLayer(props) {
  const {
    layerKey,
    layerOptions,
    onClick,
    onDoubleClick,
    onMouseEnter,
    onDrag,
    onDragEnd,
    onMouseLeave,
    beneath,
    onAnimationFrame
  } = props;
  const {
    map,
    mapStyle,
    sourceKey,
    setLayer,
    removeLayer,
    getLayer,
    debug
  } = useContext(SourceChildContext);
  const [initialLayerOptions] = useState(layerOptions);
  const [initialBeneath] = useState(beneath);
  const [initialDebug] = useState(debug);
  const animationKeyRef = useRef();

  // Add layer in mapboxgl
  useEffect(() => {
    if (!map || !sourceKey || !layerKey) {
      return noop;
    }
    const id = getLayerName(sourceKey, layerKey);
    if (initialDebug) {
      // eslint-disable-next-line no-console
      console.warn(`Creating new layer: ${id}`);
    }
    const newLayerOptions = removeUndefined({
      ...initialLayerOptions,
      id,
      source: sourceKey
    });
    map.addLayer(newLayerOptions, initialBeneath);
    const destroy = () => {
      const layer = getLayer(layerKey);
      if (!layer) {
        // console.error(`No layer named: ${id}`);
        return;
      }
      removeLayer(layerKey);
    };
    setLayer(layerKey, () => ({
      name: layerKey,
      destroy
    }));
    return destroy;
  }, [map, mapStyle, sourceKey, layerKey, initialLayerOptions, initialBeneath, initialDebug, getLayer, removeLayer, setLayer]);

  // Notify modification on layer
  useEffect(() => {
    if (!map || !sourceKey || !layerKey) {
      return;
    }
    setLayer(layerKey, layer => layer && {
      ...layer,
      onClick,
      onDoubleClick,
      onMouseEnter,
      onMouseLeave,
      onDrag,
      onDragEnd
    });
  }, [map, sourceKey, layerKey, onClick, onDoubleClick, onMouseEnter, onMouseLeave, onDrag, onDragEnd, setLayer]);
  const {
    paint,
    filter,
    layout
  } = layerOptions;

  // Handle paint change
  // TODO: don't call in first render
  useEffect(() => {
    if (!map || !sourceKey || !layerKey || !paint) {
      return;
    }
    const id = getLayerName(sourceKey, layerKey);
    Object.entries(paint).forEach(_ref => {
      let [key, value] = _ref;
      map.setPaintProperty(id, key, value);
    });
  }, [map, sourceKey, layerKey, paint]);

  // Handle layout change
  // TODO: don't call in first render
  useEffect(() => {
    if (!map || !sourceKey || !layerKey || !layout) {
      return;
    }
    const id = getLayerName(sourceKey, layerKey);
    Object.entries(layout).forEach(_ref2 => {
      let [key, value] = _ref2;
      map.setLayoutProperty(id, key, value);
    });
  }, [map, sourceKey, layerKey, layout]);

  // Handle filter change
  // TODO: don't call in first render
  useEffect(() => {
    if (!map || !sourceKey || !layerKey) {
      return;
    }
    const id = getLayerName(sourceKey, layerKey);
    map.setFilter(id, filter);
  }, [map, sourceKey, layerKey, filter]);
  useEffect(() => {
    if (!map || !sourceKey || !layerKey || !onAnimationFrame) {
      return noop;
    }
    const handleAnimation = timestamp => {
      const values = onAnimationFrame(timestamp);
      if (values) {
        const id = getLayerName(sourceKey, layerKey);
        Object.entries(values).forEach(_ref3 => {
          let [key, value] = _ref3;
          map.setPaintProperty(id, key, value);
        });
      }
      animationKeyRef.current = requestAnimationFrame(handleAnimation);
    };
    animationKeyRef.current = requestAnimationFrame(handleAnimation);
    return () => {
      if (animationKeyRef.current) {
        cancelAnimationFrame(animationKeyRef.current);
      }
    };
  }, [map, sourceKey, layerKey, onAnimationFrame]);
  return null;
}

export { MapLayer as default };
//# sourceMappingURL=MapLayer.js.map
